const cmsVideos = (pathName = "") =>
    `${process.env.REACT_APP_CMS_ASSET_URL}assets/videos/${pathName}`;
  export default cmsVideos;
  